import api from '../api';
import type { MarketcheckListingsResult } from '../../types/MarketcheckActiveResult';

export interface MarketCheckSearchParams {
  year?: number;
  make: string;
  model: string;
  car_type: string;
  latitude?: number;
  longitude?: number;
  /** ZIP fallback when the buyer declines geolocation. */
  zip?: string;
  radius: number;
  trim?: string;
  /** "min-max" odometer range, e.g. "0-50000". */
  miles_range?: string;
  start?: number;
  rows?: number;
}

const carsService = {
  find: async (
    params: MarketCheckSearchParams
  ): Promise<MarketcheckListingsResult> => {
    const response = await api.get<MarketcheckListingsResult>('/listings', {
      params,
    });
    return response.data;
  },
};

export default carsService;
